/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReminderOverrides
 */
export interface ReminderOverrides {
    /**
     * 
     */
    first_reminder_delay_days?: number;
    /**
     * 
     */
    repeat_interval_days?: number;
    /**
     * 
     */
    max_reminders?: number;
    /**
     * 
     */
    send_time?: string;
    /**
     * 
     */
    paused?: boolean;
}

/**
 * Check if a given object implements the ReminderOverrides interface.
 */
export function instanceOfReminderOverrides(value: object): value is ReminderOverrides {
    return true;
}

export function ReminderOverridesFromJSON(json: any): ReminderOverrides {
    return ReminderOverridesFromJSONTyped(json, false);
}

export function ReminderOverridesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReminderOverrides {
    if (json == null) {
        return json;
    }
    return {
        
        'first_reminder_delay_days': json['first_reminder_delay_days'] == null ? undefined : json['first_reminder_delay_days'],
        'repeat_interval_days': json['repeat_interval_days'] == null ? undefined : json['repeat_interval_days'],
        'max_reminders': json['max_reminders'] == null ? undefined : json['max_reminders'],
        'send_time': json['send_time'] == null ? undefined : json['send_time'],
        'paused': json['paused'] == null ? undefined : json['paused'],
    };
}

export function ReminderOverridesToJSON(json: any): ReminderOverrides {
    return ReminderOverridesToJSONTyped(json, false);
}

export function ReminderOverridesToJSONTyped(value?: ReminderOverrides | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_reminder_delay_days': value['first_reminder_delay_days'],
        'repeat_interval_days': value['repeat_interval_days'],
        'max_reminders': value['max_reminders'],
        'send_time': value['send_time'],
        'paused': value['paused'],
    };
}

